import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "dialog"
};
const _hoisted_2 = {
  class: "dialog-footer"
};
import { ref, reactive } from "vue";
import { useI18n } from "vue-i18n";
import { ElMessage } from "element-plus";
import api from "@/api/system/roles";
export default {
  __name: 'dialog',
  emits: ["loadList"],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const {
      t
    } = useI18n();
    const title = ref("");
    const showDialog = ref(false);
    const params = reactive({
      name: "",
      // 角色名称
      remark: "",
      // 备注
      isManager: 0,
      // 是否是管理员
      id: ""
    });
    const emit = __emit;
    const formRef = ref(null);
    const rules = reactive({
      name: [{
        required: true,
        message: t("common.pleaseEnter", {
          val: t("roles.table.name")
        }),
        trigger: "blur"
      }],
      remark: [{
        required: true,
        message: t("common.pleaseEnter", {
          val: t("roles.table.remark")
        }),
        trigger: "blur"
      }]
    });
    const open = row => {
      title.value = row ? t("common.edit") + t("roles.form.name") : t("common.add") + t("roles.form.name");
      Object.assign(params, {
        name: row ? row.name : "",
        remark: row ? row.remark : "",
        isManager: row ? row.isManager : 0,
        id: row ? row.id : ""
      });
      showDialog.value = true;
    };
    const handleClose = () => {
      showDialog.value = false;
    };
    const loading = ref(false);
    const handleConfig = () => {
      formRef.value.validate(async valid => {
        if (!valid) return;
        loading.value = true;
        try {
          if (params.id) {
            await api.editRole(params);
          } else {
            await api.addRoles(params);
          }
          handleClose();
          emit("loadList");
          ElMessage.success(t("action.success"));
        } finally {
          loading.value = false;
        }
      });
    };
    __expose({
      open
    });
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_radio = _resolveComponent("el-radio");
      const _component_el_radio_group = _resolveComponent("el-radio-group");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createBlock(_component_el_dialog, {
        title: title.value,
        modelValue: showDialog.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => showDialog.value = $event),
        width: "40%"
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_button, {
          onClick: handleClose,
          size: "large"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("action.cancel")), 1)]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          size: "large",
          loading: loading.value,
          onClick: handleConfig
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("action.confirmBtn")), 1)]),
          _: 1
        }, 8, ["loading"])])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_form, {
          model: params,
          "label-width": "80px",
          rules: rules,
          size: "large",
          ref_key: "formRef",
          ref: formRef
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: _ctx.$t('roles.table.name'),
            prop: "name"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: params.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => params.name = $event),
              placeholder: _ctx.$t('common.pleaseEnter', {
                val: _ctx.$t('roles.table.name')
              }),
              clearable: ""
            }, null, 8, ["modelValue", "placeholder"])]),
            _: 1
          }, 8, ["label"]), _createVNode(_component_el_form_item, {
            label: _ctx.$t('roles.table.remark'),
            prop: "remark"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: params.remark,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => params.remark = $event),
              placeholder: _ctx.$t('common.pleaseEnter', {
                val: _ctx.$t('roles.table.remark')
              }),
              clearable: ""
            }, null, 8, ["modelValue", "placeholder"])]),
            _: 1
          }, 8, ["label"]), _createVNode(_component_el_form_item, {
            label: _ctx.$t('roles.form.administrator'),
            prop: "isManager"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_radio_group, {
              modelValue: params.isManager,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => params.isManager = $event)
            }, {
              default: _withCtx(() => [_createVNode(_component_el_radio, {
                value: 0
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("common.no")), 1)]),
                _: 1
              }), _createVNode(_component_el_radio, {
                value: 1
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("common.yes")), 1)]),
                _: 1
              })]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }, 8, ["label"])]),
          _: 1
        }, 8, ["model", "rules"])])]),
        _: 1
      }, 8, ["title", "modelValue"]);
    };
  }
};